import { createState, useState } from '@hookstate/core';
const initialState = {
    triggerEvent: false     
};

const actingOnBehalfValue = createState(initialState);

export const setActingOnBehalfOfValue = (triggerEvent) => {
    let state = {        
        triggerEvent: triggerEvent
    }
    actingOnBehalfValue.set({        
        triggerEvent: triggerEvent,
    });
    return;
};
 
export const resetActingOnBehalfOfValue = () => {
    actingOnBehalfValue.set(initialState);
    return;
}

export const useActingOnBehalfOfValue = () => {
    return useState(actingOnBehalfValue);
};


